'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
const Constants = require('constants/Constants');

require('./PlatformProduct.less');

const PlatformProductCard = require('components/Platform/PlatformProductCard/PlatformProductCard');

const Selectors = {
    el: '.PlatformProduct',

    platformFigure: '.PlatformProductSection-figure',
    platformSection: '.PlatformProductSection',
    platformCard: '.PlatformProductCard',

    sequenceWrapper: '.PlatformProduct-videos',
    sequenceWrapperInner: '.PlatformProduct-videoCard',
    sequenceVideoOrImg: '.PlatformProduct-videoCard video, .PlatformProduct-videoCard img'
};

const ChildViews = {
    'PlatformProductCard': {
        selector: '.PlatformProductCard',
        viewConstructor: PlatformProductCard
    }
};

const VideoSequenceNamePattern = 'platform_';

const VideoDurations = [
    2,
    2.034,
    2,
    2
];

const BindFunctions = [
    'onScroll',
    'setItemActive',
    'onResize',
    '_initVariables',
    'activateVideoBlock',
    'progressVideo',
    'initBlocks',
    'canVideoBeAutoPlayed',
    '_findSectionIndex'
];

module.exports = Base.extend({

    el: Selectors.el,

    events: {},

    initialize: function (options = {}) {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        Base.prototype.initialize.call(this, options);

        _.bindAll(this, BindFunctions);

        this.options = options;

        this._initVariables();
        this.viewsRegistration(ChildViews);


        setTimeout(() => {
            if (this.isMobile) {
                this.canVideoBeAutoPlayed(app.settings.hasAutoPlay);

                $(Selectors.platformCard).removeClass(Constants.cssClasses.isHide);

                app.vent.on(Events.common.resize, this.onResize);
                app.vent.on(Events.common.scroll, this.onScroll);
            } else {
                this.initBlocks();
                this.createVideo(app.settings.isIE, this.$sequenceWrapperInner);

                app.vent.on(Events.common.resize, this.onResize);
                app.vent.on(Events.common.scroll, this.onScroll);
                this.onResize();

                this.setItemActive(0, 0);

                this.blocks[0].isShown = false;
                this.blocks[0].isActive = false;

                if (!this.state.isInitialPositionSet) {
                    this.setInitialPosition();
                }
            }
        }, 10);
    },

    canVideoBeAutoPlayed: function (hasAutoPlay) {
        this.createVideo(app.settings.isIE || app.settings.isEdge || !hasAutoPlay, this.$cardsFigure);
    },

    initBlocks: function () {
        this.blocks = [];

        this.$cards.each((id, item) => {
            const $item = $(item);

            const block = {
                $el: $item,
                isActive: false
            };

            this.blocks.push(block);
        });
    },

    _initVariables: function () {
        this.countVideoLoaded = 0;
        this.$sections = this.$(Selectors.platformSection);
        this.countOfSections = this.$sections.length;
        this.$cards = this.$(Selectors.platformCard);
        this.$cardsFigure = this.$(Selectors.platformFigure);
        this.state = {
            isInitialPositionSet: false,
            blocksShown: []
        };
        this.$sequenceWrapper = this.$(Selectors.sequenceWrapper);
        this.$sequenceWrapperInner = this.$(Selectors.sequenceWrapperInner);
        this.videoSequenceAssetsFolder = this.$sequenceWrapper.data('assets-folder');
    },

    setInitialPosition: function () {
        this.state.isInitialPositionSet = true;

        if (this.isMobile) {
            return;
        }

        this.blocks.forEach((block) => {
            block.$el.addClass(Constants.cssClasses.isHide);
            block.$el.removeClass(Constants.cssClasses.isActive);
            block.isActive = false;
        });
    },

    progressVideo: function (index, progress) {
        const videoObj = this.videos[index];

        if (progress === videoObj.progress) {
            return;
        }

        $(videoObj.video || videoObj.img)
            .closest(Selectors.sequenceWrapperInner)
            .toggleClass(Constants.cssClasses.isHide, (index === 0 && progress <= 0));

        if (!videoObj.video) {
            return;
        }

        videoObj.progress = progress;
        videoObj.video.currentTime = videoObj.duration * progress;
    },

    createVideo: function (isFallback, $items) {
        const params = {
            path: `${this.videoSequenceAssetsFolder}${VideoSequenceNamePattern}`,
            className: 'PlatformProduct-video PlatformProduct-video_'
        };

        this.videos = [];

        $items.each((id, item) => {
            const $item = $(item);
            const i = id + 1;

            if (!isFallback) {
                let callbackForward = (() => {
                    this.countVideoLoaded++;

                    if (this.countVideoLoaded === this.countOfSections) {
                        this.onResize();
                    }
                });

                const videoParams = {
                    path: `${params.path}${i}.mp4`,
                    $container: $item,
                    className: `${params.className}${i}`,
                    callback: callbackForward
                };

                const video = app.utils.createVideoSequence(videoParams);

                const videoObj = {
                    video,
                    duration: VideoDurations[id],
                    progress: 0
                };

                this.videos.push(videoObj);
            } else {
                const img = $('<img>')
                    .addClass(`${params.className}${i}`)
                    .attr('src', `${params.path}${i}.png`)
                    .appendTo($item)[0];

                const imgObj = {
                    img
                };

                this.videos.push(imgObj);
            }
        });
    },

    activateVideoBlock: function (section, block, progress) {
        if (!this.videos[section]) {
            return;
        }

        $(Selectors.sequenceWrapperInner).css(Constants.cssProperties.opacity, 0);

        const $item = $(this.videos[section].video || this.videos[section].img).closest(Selectors.sequenceWrapperInner);

        if (section === 0) {
            $item.toggleClass(Constants.cssClasses.disableTransition, (progress >= 0.5));
        }

        if (section <= 0 && block <= 0 && progress <= 0) {
            $item.css(Constants.cssProperties.opacity, 0);

            return;
        }

        $item.css(Constants.cssProperties.opacity, 1);
    },

    setItemActive: function (section, index) {
        if (this.isMobile) {
            return;
        }

        const lengthSections = this.sectionsResizes.length;
        const curSection = lengthSections - (lengthSections - section);
        let offset = 0;

        for (let i = 0; i < curSection; i++) {
            offset += this.sectionsResizes[i].countCards;
        }

        let curIndex = offset + index;

        for (let i = 0; i < this.blocks.length; i++) {
            if (i <= curIndex) {
                if (!this.blocks[i].isActive) {
                    this.blocks[i].$el.removeClass(Constants.cssClasses.isHide);
                    this.blocks[i].isActive = true;
                }
            } else {
                if (this.blocks[i].isActive) {
                    this.blocks[i].$el.addClass(Constants.cssClasses.isHide);
                    this.blocks[i].isActive = false;
                }
            }
        }
    },

    onScroll: function (scrollTop) {
        let scroll;
        let activeSingleBlockHeight;
        let activeBlock;
        let progress;
        let heightCard;

        if (!this.sectionsResizes) {
            return;
        }

        let curSectionActive = this._findSectionIndex(scrollTop);

        if (!this.videos || curSectionActive < 0 || curSectionActive > this.videos.length - 1) {
            return;
        }

        let curSectionResizes = this.sectionsResizes[curSectionActive];

        if (this.isMobile) {
            let curFigureResizes = this.figureResiezes[curSectionActive];

            activeSingleBlockHeight = curFigureResizes.height;
            scroll = scrollTop - curSectionResizes.offsetTop + this.wh / 2 + activeSingleBlockHeight / 2;
            activeBlock = 0;
            progress = Math.min(scroll / activeSingleBlockHeight, 1);
        } else {
            activeSingleBlockHeight = curSectionResizes.height;
            heightCard = (activeSingleBlockHeight / curSectionResizes.countCards);
            scroll = scrollTop - curSectionResizes.offsetTop + this.wh / 2 + heightCard / 2;
            activeBlock = Math.floor(scroll / heightCard);
            progress = scroll / activeSingleBlockHeight;
        }

        if (curSectionActive >= 3 && progress > 1) {
            return;
        }

        if (this.isMobile && curSectionActive < 0 || curSectionActive === 0 && activeBlock < 0) {
            this.progressVideo(0, 0);
        }

        if (curSectionActive >= 0 && curSectionActive < this.videos.length && activeBlock >= 0) {
            this.progressVideo(curSectionActive, Math.max(Math.min(progress, 1), 0));
        }

        if (curSectionActive >= 0 && this.state.isInitialPositionSet) {
            this.state.isInitialPositionSet = false;
        }

        if (this.state.isInitialPositionSet || this.isMobile) {
            return;
        }

        if (this.state.blockActive === activeBlock && this.state.activeSection === curSectionActive) {
            return;
        }

        this.state.activeSection = curSectionActive;
        this.state.blockActive = activeBlock;
        this.setItemActive(curSectionActive, activeBlock);
        this.activateVideoBlock(curSectionActive, activeBlock, progress);
    },

    onResize: function () {
        if (!this.videos) {
            return;
        }

        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        this.wh = window.app.sizes.windowHeight;

        if (this.isMobile) {
            this.figureResiezes = _.map(this.$cardsFigure, (item) => {
                const $item = $(item);

                return {
                    height: $item.innerHeight(),
                    offsetTop: $item.offset().top
                };
            });
        }

        this.sectionsResizes = _.map(this.$sections, (item) => {
            const $item = $(item);

            return {
                height: $item.innerHeight(),
                offsetTop: $item.offset().top,
                countCards: $item.find(Selectors.platformCard).length
            };
        });

        this.onScroll(window.pageYOffset);
    },

    _findSectionIndex: function (scrollValue) {
        if (!this.videos) {
            return;
        }

        let i;
        let index = 0;

        for (i = 0; i < this.sectionsResizes.length; i++) {
            if (this.isMobile) {
                if (scrollValue + this.wh > this.sectionsResizes[i].offsetTop) {
                    index = i;
                }
            } else {
                let heightCard = this.sectionsResizes[i].height / this.sectionsResizes[i].countCards;
                if (scrollValue + this.wh / 2 + heightCard / 2 > this.sectionsResizes[i].offsetTop) {
                    index = i;
                }
            }
        }

        return index;
    }
});
